/* Copyright 2024 Marimo. All rights reserved. */
import { SlotzController } from "@marimo-team/react-slotz";

export const slotsController = new SlotzController();

export const SlotNames = {
  SIDEBAR: "sidebar",
  CONTEXT_AWARE_PANEL: "context-aware-panel",
};
